import { createContext, useContext, type Context } from 'react';

import { fg } from '@confluence/feature-gating';

import type { ForgeUIAttachmentActionExtensionType } from '../../../attachmentAction.ts';
import type { AttachmentActionDescriptorsByAttachmentId } from '../AttachmentActionExtensionProvider.tsx';

export type AttachmentActionsByAttachmentId = ReadonlyMap<
	string,
	ReadonlyArray<ForgeUIAttachmentActionExtensionType>
>;

export type AttachmentActionEligibilityData = {
	actionsByAttachmentId: AttachmentActionsByAttachmentId;
	descriptorsByAttachmentId: AttachmentActionDescriptorsByAttachmentId;
};

export const EMPTY_ACTIONS_BY_ATTACHMENT_ID: AttachmentActionsByAttachmentId = new Map();
const EMPTY_ACTIONS: ReadonlyArray<ForgeUIAttachmentActionExtensionType> = Object.freeze([]);

export const AttachmentActionEligibilityContext: Context<AttachmentActionsByAttachmentId> =
	createContext(EMPTY_ACTIONS_BY_ATTACHMENT_ID);

/** Use only this row's batch result when attachment display conditions are enabled. */
export const useEligibleAttachmentActions = (
	attachmentId: string,
	legacyExtensions: ReadonlyArray<ForgeUIAttachmentActionExtensionType>,
): ReadonlyArray<ForgeUIAttachmentActionExtensionType> => {
	const actionsByAttachmentId = useContext(AttachmentActionEligibilityContext);
	// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
	if (!fg('forge_attachment_action')) {
		return EMPTY_ACTIONS;
	}
	// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
	return fg('forge_attachment_display_conditions')
		? (actionsByAttachmentId.get(attachmentId) ?? EMPTY_ACTIONS)
		: legacyExtensions;
};
